var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var createEmptyProduct = function (uuid) {
    return {
        uuid: uuid(),
        code: "",
        name: "",
        brand: "",
        manufacturer: "",
        description: "",
        createdFromScratch: true,
        sku: "",
        metadata: "",
        active: true,
        imageUrl: "",
        price: 0,
        bestseller: false,
        businessProduct: createEmptyBusinessProduct(uuid),
        vendors: [],
    };
};
export var WholeProduct = { unit: { id: 12, name: "Whole Product", description: "" } };
export var createEmptyBusinessProduct = function (uuid) {
    return {
        uuid: uuid(),
        name: "",
        description: "",
        code: "",
        brand: "",
        manufacturer: "",
        availableForCheckout: false,
        pricing: {
            price: 0,
            taxes: []
        },
        size: __assign({}, WholeProduct),
        stock: 0,
        alert: 0,
        imageUrl: "",
        destroyable: true,
    };
};
export var createBusinessProduct = function (uuid, product) {
    return {
        uuid: uuid(),
        name: product.name,
        description: product.description,
        code: product.code,
        brand: product.brand,
        manufacturer: product.manufacturer,
        size: product.size ? __assign({}, product.size) : __assign({}, WholeProduct),
        availableForCheckout: false,
        pricing: {
            price: product.price,
            taxes: []
        },
        stock: 0,
        alert: 0,
        imageUrl: product.imageUrl,
        destroyable: true
    };
};
export var SortFields;
(function (SortFields) {
    SortFields["PRODUCT_NAME"] = "productName";
    SortFields["CATEGORY"] = "category";
    SortFields["BRAND"] = "brand";
    SortFields["MANUFACTURER"] = "manufacturer";
    SortFields["VENDOR"] = "vendor";
})(SortFields || (SortFields = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASCENDANT"] = "ascendant";
    SortOrder["DESCENDANT"] = "descendant";
    SortOrder["CREATION_DATE"] = "creationDate";
})(SortOrder || (SortOrder = {}));
